import { Card, CardBody, Col } from "reactstrap";
import { useTranslation } from "react-i18next";
import { LI, UL } from "../../../AbstractElements";
import { Link } from "react-router-dom";

function OrganizationReport() {
  const { t } = useTranslation();
  return (
    <Col xl="4" md="6">
      <Card className="custom-list-group">
        <div className="alert alert-light-primary fade show p-1 mt-3 border-top-right-radius">
          <h4 className="light-primary p-1 d-flex justify-content-center">
            {t("OrganizationReport")}
          </h4>
        </div>
        <CardBody>
          <div className="chart-overflow" style={{ height: 400 }}>
            <UL className="list-content">
              <Link to={`${process.env.PUBLIC_URL}/reports/organization-trends`}>
                <LI className="list-hover-primary">
                  <i className="icofont icofont-exclamation-circle text-danger"></i>
                  {t("OrganizationTrends")}
                </LI>
              </Link>
            </UL>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
}

export default OrganizationReport;
